/// <reference path="../_references.ts"/>

module App.Utils {
	export type OrganizationCallsourceData = {
		id: number;
		name: string;
		callsource_brand_id?: number;
		callsource_enabled: boolean;
		send_review_message: boolean;
	}

	export type OrganizationSRDisplayData = {
		id: number;
		name: string;
		lead_source_disabled: boolean;
		payment_type_disabled: boolean;
		service_request_type_disabled: boolean;
		dispatch_code_disabled: boolean;
	}

	export type OrganizationETCSettingData = {
		id: number;
		name: string;
		appointment_duration_matches_estimated_time: boolean;
	}

	export type OrganizationSSPTextData = {
		id: number;
		name: string;
		ssp_price_card_text: string;
	}

	export type OrganizationFileUploadData = {
		id: number;
		name: string;
		max_file_upload_size: number;
	}
}